import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Card,
    CardHeader,
    CardContent,
    Typography
} from "@material-ui/core";

// Chart.js v2 ben�tigt KEINE Registrierung
// react-chartjs-2@2 funktioniert out-of-the-box

export default function SentimentGaugeCard({ stats }) {
    if (!stats) {
        return (
            <Card>
                <CardHeader title="Sentiment" />
                <CardContent>
                    <Typography variant="body2">Keine Daten.</Typography>
                </CardContent>
            </Card>
        );
    }

    const buy = stats.buySignals ?? 0;
    const sell = stats.sellSignals ?? 0;
    const hold = Math.max((stats.totalSignals ?? 0) - buy - sell, 0);
    const total = buy + sell + hold || 1;

    const data = {
        labels: ["Buy", "Hold", "Sell"],
        datasets: [
            {
                label: "Sentiment",
                backgroundColor: ["#2ecc71", "#3498db", "#e74c3c"],
                borderWidth: 1,
                data: [buy, hold, sell]
            }
        ]
    };

    const options = {
        indexAxis: "y", // horizontal bar mode
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                ticks: { beginAtZero: true }
            }]
        },
        legend: { display: false }
    };

    return (
        <Card>
            <CardHeader title="Sentiment (Buy / Hold / Sell)" />
            <CardContent>
                <div style={{ height: 220 }}>
                    <Bar data={data} type="Pie" options={options} />
                </div>
                <Typography
                    variant="body2"
                    style={{
                        marginTop: 12,
                        fontFamily: "monospace",
                        fontSize: 13,
                        lineHeight: 1.6,
                    }}
                >
                    <span style={{ color: "#00ff87" }}>
                        BUY:  {buy.toString().padStart(5, " ")}
                    </span>
                    <br />
                    <span style={{ color: "#00aaff" }}>
                        HOLD: {hold.toString().padStart(5, " ")}
                    </span>
                    <br />
                    <span style={{ color: "#ff4d4d" }}>
                        SELL: {sell.toString().padStart(5, " ")}
                    </span>
                    <br />
                    <span style={{ color: "#dddddd" }}>
                        TOTAL:{total.toString().padStart(5, " ")}
                    </span>
                </Typography>
            </CardContent>
        </Card>
    );
}
